import { render, staticRenderFns } from "./digitalarchives.vue?vue&type=template&id=0b4cdef0&scoped=true&"
import script from "./digitalarchives.vue?vue&type=script&lang=js&"
export * from "./digitalarchives.vue?vue&type=script&lang=js&"
import style0 from "./digitalarchives.vue?vue&type=style&index=0&id=0b4cdef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4cdef0",
  null
  
)

export default component.exports